<template>
    <b-container class="pad-bottom--xl pad-top--sm">
      <div v-if="!crmData.use_stoke_beacon" class='mbl-5'>
        <h4 class='mb-4'>VISITOR ID FIELD</h4>
        <multiselect
          class="gray--multiselect"
          label="name"
          track-by="name"
          v-model="selectVistorObject"
          :options="vidAllObjects"
          placeholder="Select a Object"
          v-on:input="getVidFields(selectVistorObject.name)">
        </multiselect>
        <multiselect
          class="gray--multiselect"
          label="name"
          track-by="name"
          v-model="visitorField"
          :options="currentVisitorFields"
          placeholder="Select a Field"
          v-on:input="showVidSave()">
        </multiselect>
        <b-alert
          :show="dismissCountDown"
          dismissible
          @dismissed="dismissCountDown=0"
          @dismiss-count-down="countDownChanged"
          class="success"
          v-if="vidSaveMessage">{{vidSaveMessage}}</b-alert>
        <div class="d-flex justify-content-end">
          <button v-show="!hasVid" class="purple-button purple-button--squished m-3" @click="saveVisitorID">Save</button>
        </div>
        <br>
      </div>
        <hr class="separator" />
        <br>
        <h3>Import Customer Attributes</h3>
        <b-alert
          :show="dismissCountDown"
          class="error" v-if="error">{{error}}</b-alert>
        <hr class="separator" />
        <FormSelect
          v-show='aaConnection.length > 1'
          v-model='selectAdobeConnection'
          :options="aaConnection"
          selectValue="adobe_connection_id">
        </FormSelect>
        <multiselect
          class="select--multi"
          v-model="selectSfObject"
          :value="selectCrmValue"
          label="name"
          track-by="value"
          :options="crmAllObjects"
          v-on:input="getFields(selectSfObject.value)">
        </multiselect>
        <div class="tabs_panel mar-bottom--xl">
          <transition-group tag="div" name="list">
            <div class="field" v-for="(key, index) in customerAttributesSelectedFields" :key="customerAttributesSelectedFields[index].name">
              <input class="" type="checkbox" :id='index' :value="key.name" v-model="checkNames" @change="crmObjectMapFields()">
              <label  :for="index">{{key.name}}</label>
            </div>
          </transition-group>
        </div>
      <hr class="separator" />
      <div>
        <template v-if="records && checkNames && checkNames.length > 0">
          <div class="flex flex-items--center recordTable_container">
            <button class="arrow-button" @click='changeRecordsBackwards'><i class="fas fa-caret-left"></i></button>
            <div class="recordTable" ref="recordTable">
              <span v-for='key in checkNames' v-bind:key='key' class="record">
                <p class="record--head pad-right--sm">{{key}}:  </p>
                <p v-if="records[recordIndex][key] && key.includes('Date')" class="record--info"> {{records[recordIndex][key] | formatDate}}</p>
                <p v-else-if="records[recordIndex][key]" class="record--info"> {{records[recordIndex][key]}}</p>
              </span>
            </div>
            <button class="arrow-button" @click='changeRecordsForward'><i class="fas fa-caret-right"></i></button>
          </div>
        </template>
        <template v-else>
          <div class="flex flex-items--center flex--col pad-y--xl mar-top--lg pad-x--xl font-size--sm">
            <span class="pad-x--md">Please select attributes to see example data</span>
          </div>
        </template>
        <hr class="seperator mar-top--lg" />
        <span class="flex flex-justify--between flex-items--center mar-top--lg">
          <button class="ghost-button" @click="deleteCrm">Delete</button>
          <div class="flex">
            <button class="ghost-button ghost-button--condensed mar-right--sm" @click="cancel">Cancel</button>
            <button class='purple-button purple-button--squished' @click="saveAttribute">Save</button>
          </div>
        </span>
      </div>
    </b-container >
  </template>
<script>
import { setTimeout } from 'timers'
import CrmConnections from '@/api/CRM/CrmConnections.js'
import FormSelect from '@/components/FormSelect.vue'
import Multiselect from 'vue-multiselect'

export default {
  name: 'CrmSalesforce',
  components: {
    FormSelect,
    Multiselect
  },
  props: {
    crmData: {
      type: Object
    }
  },
  data () {
    return {
      checkNames: [],
      checkedFields: {},
      crmAllObjects: [],
      records: null,
      recordIndex: 0,
      selectAdobeConnection: null,
      error: '',
      selectSfObject: { 'name': 'Lead', 'value': 'Lead' },
      selectCrmValue: '',
      customerAttributesSelectedFields: [],
      allFieldsObjects: [],
      visitorField: { 'name': '' },
      selectVistorObject: { 'name': '', 'value': '' },
      currentVisitorFields: [],
      vidAllObjects: [],
      vidSaveMessage: '',
      hasVid: true,
      dismissSecs: 4,
      dismissCountDown: 0,
      isLoadingIntake: false,
      vid: {}
    }
  },
  mounted () {
    this.selectCrmValue = 'Lead'
    this.getVIDObjectsSalesforce()
    this.getFields('Lead')
    this.getVisitorID()
    this.mapObject()
    if (!this.crmData.use_stoke_beacon) {
      this.setVidFields()
    }
  },
  created () {
    this.getCustomerAttributes()
  },
  computed: {
    aaConnection () {
      return this.$store.state.data.AnalyticsData
    }
  },
  methods: {
    saveAttribute () {
      this.checkAdobeConnectionId()
      var fields = {
        'crm_connection_id': this.crmData.crm_connection_id,
        'adobe_connection_id': this.selectAdobeConnection,
        'attributes': [] }
      var checkedFields = this.checkedFields
      Object.keys(checkedFields).forEach(function (object) {
        var objectField = checkedFields[object]
        Object.keys(objectField).forEach(function (index) {
          fields.attributes.push({ 'crm_object': object, 'field': objectField[index] })
        })
      })
      this.error = ''
      CrmConnections.SaveCustomerAttributes(fields)
        .then(response => {
          if (response.error) {
            this.dismissCountDown = this.dismissSecs
            this.error = response.error
          } else {
            this.$emit('save', response.attribute_create_status + response.attribute_ftp_upload_status)
          }
        })
    },
    cancel () {
      this.checkNames = this.checkNameLeads
      this.checkedFields.Lead = this.checkNameLeads
      this.checkedFields.Contact = this.checkNameContacts
      this.select_value = 'Lead'
      this.$emit('close')
    },
    crmObjectMapFields () {
      if (!(this.selectCrmValue in this.checkedFields)) {
        this.checkedFields[this.selectCrmValue] = []
        this.checkedFields[this.selectCrmValue] = this.checkNames
      } else {
        this.checkedFields[this.selectCrmValue] = this.checkNames
      }
    },
    checkAdobeConnectionId () {
      if (this.aaConnection && this.aaConnection.length <= 1 && this.selectAdobeConnection === null) {
        this.selectAdobeConnection = this.aaConnection[0].adobe_connection_id
      }
      return this.selectAdobeConnection
    },
    getVidFields (object) {
      if (object in this.vid) {
        this.visitorField.name = this.vid[object].visitor_id_field
      } else {
        this.visitorField.name = ''
      }
      if (!this.allFieldsObjects[object]) {
        CrmConnections.salesforceFields({ 'object': object, 'connection_id': this.crmData.crm_connection_id })
          .then(response => {
            this.allFieldsObjects[object] = []
            response.response.forEach(res => {
              this.allFieldsObjects[object].push({ 'name': res.name })
            })
            this.currentVisitorFields = this.allFieldsObjects[object]
          })
      } else {
        if (object) {
          this.currentVisitorFields = this.allFieldsObjects[object]
        }
      }
      this.showVidSave()
    },
    getFields (object) {
      this.selectCrmValue = object
      if (!this.allFieldsObjects[object]) {
        CrmConnections.salesforceFields({ 'object': object, 'connection_id': this.crmData.crm_connection_id })
          .then(response => {
            this.allFieldsObjects[object] = []
            if (response.response) {
              response.response.forEach(res => {
                this.allFieldsObjects[object].push({ 'name': res.name })
              })
              this.customerAttributesSelectedFields = this.allFieldsObjects[object]
            }
          })
      } else {
        this.customerAttributesSelectedFields = this.allFieldsObjects[object]
      }
      if (this.checkedFields[object]) {
        this.checkNames = this.checkedFields[object]
      } else {
        this.checkNames = []
      }
    },
    getVIDObjectsSalesforce () {
      CrmConnections.sfObject(this.crmData.crm_connection_id, true)
        .then(response => {
          response.forEach(resp => {
            this.vidAllObjects.push({ 'name': resp, 'value': resp })
          })
        })
    },
    getVisitorID () {
      CrmConnections.getVistitorId(this.crmData.crm_connection_id)
        .then(response => {
          if (Object.keys(response).length >= 1) {
            var vid = this.vid
            var setVid = response.filter(function (select) {
              var object = select.sfdc_object
              vid[object] = select
              return vid
            })[0]
            if (!this.selectVistorObject.value) {
              if ('Lead' in vid) {
                this.selectVistorObject.value = vid.Lead.sfdc_object
                this.selectVistorObject.name = vid.Lead.sfdc_object
                this.visitorField.name = vid.Lead.visitor_id_field
              } else {
                this.selectVistorObject.value = response[0].sfdc_object
                this.selectVistorObject.name = response[0].sfdc_object
                this.visitorField.name = response[0].visitor_id_field
                this.getVidFields(response[0].sfdc_object)
              }
            } else if (!this.selectVistorObject.value) {
              this.hasVid = false
            }
          }
        })
    },
    saveVisitorID () {
      var data = {}
      var selectedObject = this.selectVistorObject.value
      if (this.vid && this.selectVistorObject.value in this.vid) {
        data = {
          'visitor_id_mapping_id': this.vid[selectedObject].visitor_id_mapping_id,
          'visitor_id_field': this.visitorField.name,
          'sfdc_object': this.selectVistorObject.value,
          'crm_connection_id': this.crmData.crm_connection_id
        }
      } else {
        data = {
          'visitor_id_field': this.visitorField.name,
          'sfdc_object': this.selectVistorObject.value,
          'crm_connection_id': this.crmData.crm_connection_id
        }
      }
      this.vidSaveMessage = 'Successfully created and saved visitor id field mapping.'
      this.hasVid = true
      this.dismissCountDown = this.dismissSecs
      CrmConnections.postVistitorId(data)
        .then(response => {
          this.vidSaveMessage = response.status
          this.getVisitorID()
          this.mapObject()
        })
    },
    setVidFields () {
      if (this.selectVistorObject.name) {
        setTimeout(() => {
          this.getVidFields(this.selectVistorObject.name)
        }, 200)
      }
    },
    getCustomerAttributes () {
      this.checkedFields = {}
      CrmConnections.getCustomerAttributes(this.crmData.crm_connection_id)
        .then(response => {
          var attributes = response.attributes
          if (attributes.length > 0) {
            attributes.forEach(resp => {
              if (!(resp.crm_object in this.checkedFields)) {
                this.checkedFields[resp.crm_object] = []
              }
              if (!this.checkedFields[resp.crm_object].includes(resp.field)) {
                this.checkedFields[resp.crm_object].push(resp.field)
              }
            })
            this.checkNames = this.checkedFields[this.selectCrmValue]
          } else {
            this.checkNames = []
          }
          return this.checkedFields
        })
    },
    mapObject () {
      this.crmAllObjects = []
      CrmConnections.sfObject(this.crmData.crm_connection_id)
        .then(response => {
          if (response.error) {
            this.error = response.error
          } else {
            response.forEach(resp => {
              this.crmAllObjects.push({ 'name': resp, 'value': resp })
            })
          }
          return response
        })
      CrmConnections.getSfRecords({ 'crm_connection_id': this.crmData.crm_connection_id, 'sfObject': this.selectCrmValue })
        .then(response => {
          this.records = response
          return this.records
        })
    },
    deleteCrm () {
      this.$emit('deleteData')
    },
    changeRecordsForward () {
      var recordCount = ''
      this.$refs.recordTable.classList.add('faded')
      recordCount = this.records.length - 1
      setTimeout(() => {
        if (this.recordIndex >= recordCount) {
          this.recordIndex = 0
        } else {
          this.recordIndex = this.recordIndex + 1
        }
        this.$refs.recordTable.classList.remove('faded')
      }, 400)
    },
    changeRecordsBackwards () {
      var recordCount = ''
      this.$refs.recordTable.classList.add('faded')
      recordCount = this.records.length - 1
      setTimeout(() => {
        if (this.recordIndex > 0) {
          this.recordIndex = this.recordIndex - 1
        } else {
          this.recordIndex = recordCount
        }
        this.$refs.recordTable.classList.remove('faded')
      }, 400)
    },
    showVidSave () {
      this.hasVid = false
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    handleScroll: function (evt) {
      if (window.scrollY > 50) {
      }
      return window.scrollY > 100
    }
  }
}
</script>
